<template>
  <div class="win">
    <div class="back" v-if="certificate">
      <div class="content" :style="scale">
        <h2>美国培声听力语言中心及其博鳌培声国际医学中心</h2>
        <h1>授予 {{ certificate.name }}</h1>
        <h5>{{ certificate.certificate_type_id.name }}</h5>
        <h4>
          证书颁发日期：<span>{{
            moment(certificate.get_time).format('YYYY-MM-DD')
          }}</span>
        </h4>
        <h4 class="line-2-3">
          证书有效日期：<span>{{
            moment(certificate.invalid_time).format('YYYY-MM-DD')
          }}</span>
        </h4>
        <h4 class="line-2-3">
          证书编号：<span>{{ certificate.certificate_code }}</span>
        </h4>
        <div class="qr-container">
          <qr-code :text="qrcodeUrl" size="126"></qr-code>
        </div>
      </div>
      <p @click="onClick" class="bottom-text">
        更多证书信息请访问 <strong>培声官网</strong>
      </p>
    </div>
  </div>
</template>

<script>
import queryString from 'query-string';
import axios from 'axios';
import moment from 'moment';
export default {
  name: 'VideoPlayerLand',
  data: function() {
    return {
      scale: 'scale: 1',
      certificate: {
        get_time: '2023年3月4号',
        invalid_time: '2023年3月4号',
        certificate_code: 'XFCCCA',
      },
      qrcodeUrl: window.location.href,
    };
  },
  mounted() {
    const searchString = location.hash.split('?')[1];
    const searchParams = queryString.parse(searchString);
    axios
      .get(
        `https://portal.ourbethel.cn/api/base/certificates/detail_from_mobile_web?certificate_id=${searchParams.certificate_id}`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          this.certificate = res.data.data;
        }
      });

    const screenWHRatio = window.innerHeight / window.innerWidth;
    const _scale = screenWHRatio < 2 ? 0.9 : window.innerWidth / 390;
    this.scale = `scale: ${Math.min(_scale, 1.4)}`;
  },
  methods: {
    moment,
    onClick() {
      window.location.href = 'https://www.ourbethel.cn/cert';
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.win {
  background-color: #3f7eef;
  width: 100vw;
  min-height: 100vh;
}

.back {
  background-image: url('../assets/certificate_back.png');
  width: 100vw;
  background-size: contain;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content {
  background-image: url('../assets/certificate_content.png');
  width: 350px;
  height: 705px;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 40px;
}

h2 {
  color: #153b60;
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  padding: 0;
  margin-top: 100px;
  width: 230px;
}

h1 {
  color: #153b60;
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  padding: 0;
  margin-top: 30px;
  width: 230px;
}

h5 {
  color: white;
  margin: 0;
  padding: 0;
  margin-top: 110px;
  width: 270px;
  height: 50px;
  font-size: 16px !important;
}

h4 {
  padding: 0;
  margin: 0;
  margin-top: 30px;
  font-size: 16px;
  color: #153b60;
  font-weight: bold;
  width: 230px;
  text-align: left;
}

h4 span {
  color: #fc9a2c;
}

.line-2-3 {
  margin-top: 5px;
}

.qr-container {
  border: 3px solid #fc9a2c;
  height: 140px;
  width: 140px;
  margin-top: 20px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-container qr-code {
  box-sizing: border-box;
  padding: 5px;
}

.bottom-text {
  color: white;
  font-size: 20px;
  margin-top: 50px;
}
</style>
